export const TIP = 'tip';
export const SUPPORT = 'support';
export const CHANNEL = 'channel';
export const UPDATE = 'update';
export const ALL = 'all';
export const SPEND = 'spend';
export const RECEIVE = 'receive';
export const PUBLISH = 'publish';
export const ABANDON = 'abandon';
